/**
 * Contexts where a first-run tour must never appear.
 *
 * Embedded panes (the hub hosting a sibling in an iframe, `?embed=1`) and the
 * embeddable chat widget (`/dock`) are chrome-less or too small to spotlight;
 * a tour starting there would also double-fire once the user opens the same
 * application standalone. Hosts may pass `enabled: false` themselves — this
 * helper is the shared definition, so every surface suppresses the same way.
 */
export function isEmbeddedSurface(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has("embed") || params.has("embedMode") || params.has("pane")) return true;
    const path = window.location.pathname;
    return path === "/dock" || path.startsWith("/dock/");
  } catch {
    return false;
  }
}
